export const UMB_USER_GROUP_ITEM_REPOSITORY_ALIAS = 'Umb.Repository.UserGroupItem';
export const UMB_USER_GROUP_STORE_ALIAS = 'Umb.Store.UserGroupItem';
export { UMB_USER_GROUP_ITEM_STORE_CONTEXT } from './user-group-item.store.token.js';
